import { render, staticRenderFns } from "./erpModal.vue?vue&type=template&id=4346bfd2&scoped=true"
import script from "./erpModal.vue?vue&type=script&lang=js"
export * from "./erpModal.vue?vue&type=script&lang=js"
import style0 from "./erpModal.vue?vue&type=style&index=0&id=4346bfd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4346bfd2",
  null
  
)

export default component.exports